import React from 'react';
import { ArrowDownOutlined, ArrowUpOutlined, BulbOutlined, MobileOutlined, } from '@ant-design/icons';
import { Card, Col, Divider, Row, Statistic, Typography } from 'antd';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { CONFIGMERCHENT } from '../../Data/configMerchant';

const { Text } = Typography;
const ReportCustomersSummary = ({ isLoadReportCustomers, locale, data, t }) => {

    const styles = {
        warn: {
            margin: '26px 0 10px 0',
            backgroundColor: '#e6f4ff', // พื้นหลังสีฟ้าอ่อน
            border: '1px solid #91caff',
            borderLeft: '5px solid #1677ff', // เส้นขอบซ้ายสีน้ำเงินหลัก
            borderRadius: '14px',
            padding: '18px 20px',
            display: 'flex',
            gap: '14px',
            boxSizing: 'border-box'
        },
        warnIc: {
            flex: '0 0 auto',
            width: '34px',
            height: '34px',
            borderRadius: '9px',
            backgroundColor: '#1677ff', // พื้นหลังไอคอนสีน้ำเงิน
            color: '#fff',
            display: 'grid', // เปลี่ยนจาก none เป็น grid เพื่อให้แสดงผลและอยู่ตรงกลาง
            placeItems: 'center',
            border: '1px solid #91caff'
        },
        warnH3: {
            fontFamily: '"Kanit", sans-serif',
            fontWeight: 600,
            fontSize: '16px',
            color: '#002c8c', // เปลี่ยนสีหัวข้อให้เข้ากับโทนฟ้า
            margin: '0 0 4px 0'
        },
        warnP: {
            margin: 0,
            fontSize: '14.5px',
            color: '#003a8c' // เปลี่ยนสีเนื้อหาให้เข้ากับโทนฟ้า
        },
    };


    let fs = 16; // ขนาดฟอนต์เริ่มต้น

    let colorUp = 'green';
    let colorDown = 'red';
    let colorEqual = '#5a5a5a'; // สีเทาสำหรับค่าเท่ากัน
    let colorTotal = 'rgb(22, 119, 255)'; // สีฟ้าเข้มสำหรับสรุปทั้งหมด

    let UpIcon = <ArrowUpOutlined style={{ color: colorUp, fontSize: fs }} />;
    let DownIcon = <ArrowDownOutlined style={{ color: colorDown, fontSize: fs }} />;
    let EqualIcon = null;
    let TotalIcon = <MobileOutlined style={{ color: colorTotal, fontSize: fs }} />;

    // ดึงค่ามาใช้งานจริงจากพรอพ data (ถ้าไม่มีค่า ให้ Default เป็น 0)
    let from_start = data?.from_start?.count || 0;
    let last_month = data?.last_month?.count || 0;
    let this_month = data?.this_month?.count || 0;

    // ดึงป้ายกำกับ/ข้อความอัปเดต (หากต้องการนำไปต่อท้าย title หรือระบุเพิ่มในอนาคต)
    let last_month_updated = dayjs(data?.last_month?.label).format("MMM YYYY") || "N/A";
    let this_month_updated = dayjs(data?.this_month?.label).format('MMM YYYY') || "N/A";

    const formatter = (value) => <CountUp style={{ fontSize: fs }} end={value} separator="," />;

    // กำหนดสีและไอคอนสำหรับเดือนที่แล้วตามเงื่อนไข
    let isColorLast_month = last_month > this_month ? colorUp : last_month === this_month ? colorEqual : colorDown;
    let isIconLast_month = last_month > this_month ? UpIcon : last_month === this_month ? EqualIcon : DownIcon;

    let isColorThis_month = this_month > last_month ? colorUp : this_month === last_month ? colorEqual : colorDown;
    let isIconThis_month = this_month > last_month ? UpIcon : this_month === last_month ? EqualIcon : DownIcon;

    return (
        <>
            <Divider orientation='left'>{t("Report Tel. Summary")}</Divider>

            <Row gutter={16}>
                {/* 1. สรุปทั้งหมดตั้งแต่เริ่ม */}
                <Col span={8}>
                    <Card variant="borderless" className='p-3'>
                        <Statistic
                            loading={isLoadReportCustomers}
                            title={<Text color={colorTotal} style={{ color: colorTotal, fontWeight: 700 }} >{t("Total Tel. Data")}</Text>}
                            value={from_start}
                            precision={0} // จำนวนคนปรับความแม่นยำเป็นทศนิยม 0 ตำแหน่ง
                            valueStyle={{ color: colorTotal }}
                            prefix={TotalIcon}
                            formatter={() => formatter(from_start)}
                        />
                    </Card>
                </Col>
                {/* 2. สรุปเดือนที่แล้ว */}
                <Col span={8}>
                    <Card variant="borderless" className='p-3'>
                        <Statistic
                            title={<Text style={{ color: isColorLast_month, fontWeight: 700 }}>{t("Last Month")} ({last_month_updated})</Text>}
                            loading={isLoadReportCustomers}
                            value={last_month}
                            precision={0}
                            valueStyle={{ color: isColorLast_month }}
                            prefix={isIconLast_month}
                            formatter={() => formatter(last_month)}
                        />
                    </Card>
                </Col>
                {/* 3. สรุปเดือนนี้ */}
                <Col span={8}>
                    <Card variant="borderless" className='p-3'>
                        <Statistic
                            title={<Text style={{ color: isColorThis_month, fontWeight: 700 }}>{t("This Month")} ({this_month_updated})</Text>}
                            loading={isLoadReportCustomers}
                            value={this_month}
                            precision={0}
                            valueStyle={{ color: isColorThis_month }}
                            prefix={isIconThis_month}
                            formatter={() => formatter(this_month)}
                        />
                    </Card>
                </Col>
            </Row>

            {/* Note บล็อกคำเตือน */}
            <div style={styles.warn}>
                <span style={styles.warnIc}>
                    <BulbOutlined />
                </span>
                <div>
                    <h3 style={styles.warnH3}>{t('note')}</h3>
                    <p style={styles.warnP}>
                        {t("*เฉพาะ Programmer เท่านั้น ที่มองเห็น Report Customers Summary")} <br />
                        {t("*ข้อมูลนี้อ้างอิงจากเบอร์โทรศัพท์ที่ผ่านการตรวจสอบแล้วเท่านั้น")} <br />
                        {`*ข้อมูลนี้จะไม่นับรวมกับร้านค้า ${CONFIGMERCHENT.join(", ")}`}
                    </p>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    // Map your state to props here if needed
});

const mapDispatchToProps = {
    // Define any actions you want to dispatch here
};
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReportCustomersSummary));